import React from 'react'
import { IconProps } from '../../../common/types'
const PrintIcon: React.FC<IconProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 128 128"
      width="12em"
      height="12em"
    >
      <path
        fill="#757575"
        d="M98.27 44.34H29.73l4.48-27.88c0-1.9 1.54-3.45 3.45-3.45h52.97c1.9 0 3.45 1.54 3.45 3.45z"
      ></path>
      <path
        fill="#424242"
        d="M92.94 41.9H35.06l3.78-23.55c0-1.61 1.3-2.91 2.91-2.91h44.74c1.61 0 2.91 1.3 2.91 2.91z"
      ></path>
      <path
        fill="#424242"
        d="M94.54 29.91H33.57c-2.46 0-4.56 1.77-4.98 4.19L26.8 44.38h74.38l-1.67-10.23c-.38-2.45-2.5-4.24-4.97-4.24"
      ></path>
      <linearGradient
        id="notoPrinter0"
        x1="64.684"
        x2="64.684"
        y1="30.827"
        y2="2.137"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".566" stopColor="#EEE"></stop>
        <stop offset="1" stopColor="#E0E0E0"></stop>
      </linearGradient>
      <path
        fill="url(#notoPrinter0)"
        d="M39.83 38.74h50.69s2.69-18-1.78-34.47H38.05c3.32 15.47 1.78 34.47 1.78 34.47"
      ></path>
      <path fill="#BDBDBD" d="m39.01 43.56l51.05-.64l.74-6.01H40.17z"></path>
      <path
        fill="#CFD8DC"
        d="M119.16 90.78H14.88c-5.6 0-6.27-10.22-5.99-16.69c.07-1.52.33-3.01.77-4.47l6.91-23.25s1.93-6.86 8.05-6.86h77.47c4.73 0 6.64 5.31 6.64 5.31l9 23.06c.84 2.16 1.29 4.46 1.3 6.79z"
      ></path>
      <path
        fill="#90A4AE"
        d="M110.89 111.17H17.11c-4.55 0-8.24-3.69-8.24-8.24V76.05c0-3.5 2.84-6.34 6.34-6.34h97.58c3.5 0 6.34 2.84 6.34 6.34v26.88c0 4.55-3.69 8.24-8.24 8.24"
      ></path>
      <path
        fill="#607D8B"
        d="M92.1 39.51H36.39l-8.8 30.2v7.26c0 3.57 2.9 6.47 6.47 6.47h59.9c3.57 0 6.47-2.9 6.47-6.47v-7.26z"
      ></path>
      <path
        fill="#90A4AE"
        d="m31.52 64.93l6.53-25.42h52.43l6.19 25.5c.83 3.56-1.59 4.7-4.89 4.7H36.39c-3.33 0-5.75-1.19-4.87-4.78"
      ></path>
      <circle cx="109.93" cy="79.84" r="3.45" fill="#424242"></circle>
      <circle cx="109.93" cy="79.25" r="3.45" fill="#99D45B"></circle>
      <path
        fill="#616161"
        d="M106.24 118.59L98.87 94.3H29.13l-7.37 24.29c-.71 2.6 1.8 5.13 5.01 5.13h74.47c3.2.01 5.72-2.52 5-5.13"
      ></path>
      <path
        fill="#212121"
        d="M96.5 100.95c-.37-1.8 1.09-2.35 1.58-2.5c1.15-.36 2.1.21 2.1.21l-1.24-4.36H29.06l-1.24 4.36s.95-.57 2.1-.21c.49.15 1.95.7 1.58 2.5c-.32 1.57-1.6 7.68-1.6 7.68c-.55 2.51-.88 5.07-1.33 7.6c0 1.44 1.32 2.6 2.95 2.6h64.94c1.63 0 2.95-1.16 2.95-2.6c-.44-2.53-.78-5.09-1.33-7.6c.01 0-1.26-6.11-1.58-7.68"
      ></path>
      <path
        fill="#BDBDBD"
        d="M55.4 106.09s-20.05 7.62 4.29 7.62s34.75-6.67 34.75-6.67l-5.63-5.46l-28.07 2.61z"
      ></path>
      <path
        fill="#FFF"
        d="M93.06 97.59H37.07l-4.76 15.85s15.89.26 27.39.26s26.07-9.34 26.07-9.34s9.51 5.68 8.98 1.46c-.62-4.82-1.69-8.23-1.69-8.23"
      ></path>
      <path fill="#BDBDBD" d="m93.49 99.14l-.75-3l-55.35.21l-.77 2.79z"></path>
      <path
        fill="#9E9E9E"
        d="M81.69 106.72H38.44l-.31 1.03h41.52zm-41.94-4.37l-.31 1.03h50.15c-.05-.35-.1-.7-.15-1.03z"
      ></path>
      <path
        fill="#757575"
        d="M88.58 98.13H41.02l-.31 1.03h48.12c-.09-.39-.17-.73-.25-1.03"
      ></path>
      <path
        fill="#607D8B"
        d="M66.96 85.5h-5.92c-1.36 0-2.47-1.1-2.47-2.47v-.4c0-1.36 1.1-2.47 2.47-2.47h5.92c1.36 0 2.47 1.1 2.47 2.47v.4c0 1.37-1.11 2.47-2.47 2.47"
      ></path>
      <path
        fill="#212121"
        d="M93.87 90.44H34.13c-2.94 0-5.32 2.38-5.32 5.32h70.37c.01-2.94-2.38-5.32-5.31-5.32"
      ></path>
    </svg>
  )
}

export default PrintIcon
